import { Tooltip } from "react-tooltip";
import Button from "shared/components/Button";
import { ReactComponent as MapButtonSVG } from "assets/icons/map.svg";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { setShowMap } from "features/krpano/details-slice";
import { DELAY_SHOW } from "shared/helpers/reactTooltip";

interface MapButtonProps {}

const MapButton: React.FC<MapButtonProps> = () => {
  const showMap = useAppSelector((state) => state.krpano.showMap);
  const dispatch = useAppDispatch();

  return (
    <div data-tooltip-id="KEY_BUTTON_MAP">
      <Button
        colour="Theme"
        additionalClassNames={`PrimaryButton SVGButton ${
          showMap ? "Active" : ""
        } NoBorder`}
        disabledClass="DisabledOpacity"
        onClick={() => {
          dispatch(setShowMap(!showMap));
        }}
        children={
          <MapButtonSVG
            height={20}
            width={20}
            role="button"
            aria-label="Toggle map"
          />
        }
      />
      <Tooltip
        id="KEY_BUTTON_MAP"
        place="top"
        className="ToolTip"
        delayShow={DELAY_SHOW}
        children="Map"
      />
    </div>
  );
};

export default MapButton;
